var _defs, _path, _path2, _path3, _path4, _path5, _path6, _line, _line2, _line3, _line4, _line5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductSummary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "maps-pin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.13,4.875a.375.375,0,0,1,.375.375"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.755,5.25a.375.375,0,0,1,.375-.375"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.13,5.625a.375.375,0,0,1-.375-.375"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.505,5.25a.375.375,0,0,1-.375.375"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.13.75a4.5,4.5,0,0,1,4.5,4.5c0,1.921-2.688,5.576-3.909,7.138a.75.75,0,0,1-1.182,0C10.318,10.827,7.63,7.171,7.63,5.25A4.5,4.5,0,0,1,12.13.75Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.135,9.781a1.5,1.5,0,0,0-1.108.97l-3.441,10.5A1.5,1.5,0,0,0,3,23.25H21.26a1.5,1.5,0,0,0,1.414-2l-3.441-10.5a1.5,1.5,0,0,0-1.117-.971"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 7.63,
    y1: 23.249,
    x2: 9.13,
    y2: 14.25
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 16.63,
    y1: 23.249,
    x2: 15.13,
    y2: 14.25
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 2.434,
    y1: 18.75,
    x2: 21.855,
    y2: 18.75
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 3.88,
    y1: 14.25,
    x2: 9.13,
    y2: 14.25
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 15.13,
    y1: 14.25,
    x2: 20.38,
    y2: 14.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductSummary);
export default __webpack_public_path__ + "static/media/product-summary.5f60cbb0d27dabe53e2d0d2c99529523.svg";
export { ForwardRef as ReactComponent };